import React from 'react';
import Box from '@mui/material/Box';

const NotFound =  ({}) => {
  return (
    <div class="title">
    <h2>404 Not Found :(</h2>
    <Box id="nothingFound poem">
        “Poetry” does not exist,<br />
        and “poems” are a lie<br />
        Even though people insist,<br />
        And many always deny,<br />
        Some of them always persist<br />
        That it can actually be defined.<br />

    </Box>
</div>
  );
}

export default NotFound;